import React, { useEffect, useState } from "react";
import PublicacaoSwiper from "./components/PublicacaoSwiper";
import api from "../Services/api";
import "./Publicacoes.css";

interface PublicacaoData {
  ID: number;
  Title: string;
  URL: string;
  Descricao: string;
  Data_x0020_Publicacao: string;
}

const Publicacoes: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [postagens, setPostagens] = useState<PublicacaoData[]>([]);
  const [swiperIndex, setSwiperIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      const ismobile = window.innerWidth < 769;
      if (ismobile !== isMobile) setIsMobile(ismobile);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobile]);

  useEffect(() => {
    const fetchPublicacoes = async () => {
      try {
        setIsLoading(true);
        const response = await api.get("/ObterPublicacoesHome");
        setPostagens(response.data.results || []);
      } catch (error) {
        console.error("Erro ao carregar publicações:", error);
        setPostagens([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPublicacoes();
  }, []);

  if (isLoading) {
    return (
      <section className="publicacoes-container">
        <div className="publicacoes-loading">
          <p>Carregando publicações...</p>
        </div>
      </section>
    );
  }

  return (
    <section className="publicacoes-container">
      <div className="publicacoes-inner">
        {/* Header */}
        <div className="publicacoes-header">
          <div className="publicacoes-title-section">
            <h2 className="publicacoes-title">
              <span className="publicacoes-title-desktop">Publicações</span>
              <span className="publicacoes-title-mobile">Publicações</span>
            </h2>
            {/* Link Ver Todas - movido para baixo do título */}
            <div className="publicacoes-see-all-wrapper">
              <a
                href="../acontece-na-forluz/publicacoes"
                className="publicacoes-see-all"
              >
                <span>Acessar todas as publicações</span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.172 7.00017L6.808 1.63617L8.222 0.222168L16 8.00017L8.222 15.7782L6.808 14.3642L12.172 9.00017H0V7.00017H12.172Z"
                    fill="currentColor"
                  />
                </svg>
              </a>
            </div>
          </div>

          {/* Swiper de Publicações */}
          <div className="publicacoes-content">
            <PublicacaoSwiper postagens={postagens} swiperIndex={swiperIndex} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Publicacoes;
